/* eslint-disable react/prop-types */
// ./TituloDivisor.jsx
import React from 'react';
import { Divider, Typography } from 'antd';

const { Title } = Typography;

export default function TituloDivisor({ children }) {
  return (
    <Divider
      orientation="left"
      orientationMargin={0}
      style={{
        borderColor: 'gray',
        marginTop: 24,
        marginBottom: 16,
        paddingLeft: 0,
      }}
    >
      <Title level={4} strong>{children}</Title>
    </Divider>
  );
}
